import React from "react";

const TableRowSkeleton = ({ avatar, columns = 5 }) => {
  return (
    <tr>
      {avatar && (
        <>
          <td className="px-4 py-3" style={{ paddingRight: 0 }}>
            <div className="w-10 h-10 rounded-full bg-dark-200 dark:bg-dark-700 animate-pulse" />
          </td>
          <td className="px-4 py-3">
            <div className="h-5 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
          </td>
        </>
      )}
      {Array.from({ length: columns }, (_, index) => (
        <td key={index} className="px-4 py-3">
          <div className="flex items-center justify-center">
            <div className="h-5 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
          </div>
        </td>
      ))}
    </tr>
  );
};

export default TableRowSkeleton;
